<template>
    <div class="horizontal-slide-container">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <a class="item" :class="{ active: value == undefined }" href="#" @click="input(undefined)">전체</a>
                </div>
                <div v-for="(category, index) in categories" :key="index" class="swiper-slide">
                    <a class="item" :class="{ active: value == category._id }" href="#" @click="input(category._id)">{{ category.name }}</a>
                </div>
            </div>
        </div>
        <div class="prev">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10px" height="12px">
                <path fill-rule="evenodd"  stroke="rgb(255, 184, 29)" stroke-width="2px" stroke-linecap="round" stroke-linejoin="miter" fill="none" d="M8.706,3.667 L4.782,7.516 L8.706,11.364 "/>
            </svg>
        </div>
        <div class="next">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10px" height="12px">
                <path fill-rule="evenodd"  stroke="rgb(255, 184, 29)" stroke-width="2px" stroke-linecap="round" stroke-linejoin="miter" fill="none" d="M3.231,1.667 L7.155,5.516 L3.231,9.364 "/>
            </svg>
        </div>
        <span class="border"></span>
    </div>
</template>

<script>
import api from "@/api";
export default{
    props: {
        value: { type: String, default: null }
    },
    data() {
        return{
            categories: null
        }
    },
	mounted() {
		this.init();
	},
	methods: {
		async init() {
            try{
                var { categories } = await api.v1.shop.categories.getCategories();
                this.categories = categories;
                this.render();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
		},
        input(_category){
            this.$emit("input", _category);
        },
        render(){
            this.$nextTick(() => {
                var horizontalSlide = new Swiper ('.horizontal-slide-container .swiper-container', {
                    slidesPerView: 'auto',
                    spaceBetween : 0,
                    // freeMode: true,
                    speed: 200,
                    loop: false,
                    navigation: {
                        nextEl: '.horizontal-slide-container .next',
                        prevEl: '.horizontal-slide-container .prev'
                    },
                });

                // 아이템 Active
                (function(){
                    var items = document.querySelectorAll('.horizontal-slide-container .item');

                    items.forEach((item) => {
                        item.addEventListener('click', activeItem);
                    });

                    function activeItem(){
                        items.forEach((item) => {
                            item.classList.remove('active');
                        });
                        this.classList.add('active');
                    }
                })();
            });
        }
	},
}
</script>
<style lang="scss" scoped>
    .swiper-button-disabled { opacity: 1; visibility: visible; }

    .horizontal-slide-container {
        position: relative; padding: 0 25px; border-top: 1px solid #e9e9e9;
        .border { z-index: 2; position: absolute; bottom: 0; left: 0; width: 100%; height: 1px; background: #e9e9e9; }
        .swiper-container { z-index: 3; }
        .swiper-container::before,
        .swiper-container::after { content: ''; z-index: 2; position: absolute; top: 0; width: 25px; height: calc(100% - 1px); }
        .swiper-container::before { left: 0; background-image: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%); }
        .swiper-container::after { right: 0; background-image: linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%); }
        .swiper-slide { width: auto; }
        .prev,
        .next { display: flex; align-items: center; justify-content: center; z-index: 3; position: absolute; top: 0; bottom: 0; margin: auto; width: 30px; height: 30px; }
        .prev { left: 0; }
        .next { right: 0; }
        .item { display: block; position: relative; line-height: 1; margin: 10px 20px; padding: 10px 5px; font-size: 18px; color: #999999; font-weight: 500; }
        .item::before { content: ''; position: absolute; bottom: -10px; left: 0; width: 100%; height: 2px; background: transparent; }
        .item.active { color: #ffb81d; }
        .item.active::before { background: #ffb81d; }
    }

    @media(max-width:1200px){
        .horizontal-slide-container{
            margin-right: -15px; margin-left: -15px; width: calc(100% + 30px);
            .item { margin: 10px 14px; padding: 6px 2px; font-size: 15px; }
        }
    }
    @media(max-width:768px){
        .horizontal-slide-container{
            padding: 0;
            .prev,
            .next { display: none; }
        }
    }
</style>
